<template>
  <RoleSingle
    :role="role"
  />
</template>

<script>
import RoleSingle from '../../components/RoleSingle'

export default {
  name: 'RoleSinglePage',

  components: {
    RoleSingle
  },

  async beforeRouteLeave (to, from, next) {
    if (this.role && this.role.isChanged) {
      const answer = await this.$root.$confirm(this.$t('Attention'), this.$t('You have unsaved changes. Are you sure want to leave?'), { color: 'primary' })
      if (answer) {
        this.role.reset()
      }
      return next(answer)
    }
    next()
  },

  actionBar () {
    return {
      title: 'Role',
      actions: [
        {
          text: 'Back',
          event: 'back',
          disabled: false
        },
        {
          text: 'Save',
          event: 'save',
          disabled: true
        },
        {
          color: 'error',
          text: 'Delete',
          event: 'delete',
          disabled: true
        }
      ]
    }
  },

  data () {
    return {
      role: {}
    }
  },

  computed: {
    isCreate () {
      return this.$route.params.id === '__'
    },

    saveActionStates () {
      return {
        disabled: !this.role || this.role.inProgress || !this.role.isChanged || this.role.errors.length,
        loading: !this.role || this.role.inProgress
      }
    },

    deleteActionStates () {
      return {
        disabled: !this.role || this.role.inProgress || this.isCreate
      }
    }
  },

  async mounted () {
    try {
      this.role = this.isCreate ? this.$http.make('auth:role') : await this.$http.make('auth:role').find(this.$route.params.id)
      this.role.reset()

      if (this.isCreate) {
        this.$radio.$emit('action-panel-title', 'New Role')
      } else {
        this.$radio.$emit('action-panel-title', this.role.name)
      }
    } catch (e) {
      this.$toast.error(this.$t(e.message))
    }
  },

  methods: {
    goBack () {
      this.$router.push({ name: 'roles' })
    },

    onActionBack () {
      this.goBack()
    },

    async onActionSave () {
      try {
        this.role.permission_ids = this.role.permissions
          ? this.role.permissions.map(item => typeof item === 'object' ? item.id : item) : []
        this.role.user_ids = this.role.users
          ? this.role.users.map(item => typeof item === 'object' ? item.id : item) : []
        await this.role.save()

        if (this.isCreate) {
          this.$router.replace({
            name: 'single_role',
            params: { id: this.role.id }
          })
          this.$radio.$emit('action-panel-title', this.role.name)
          this.$toast.success(this.$t('Role created'))
          return
        }
        this.$toast.success(this.$t('Role updated'))
      } catch (e) {
        this.$vuetify.goTo(0)
        this.$toast.error(this.$t(e.message))
      }
    },

    async onActionDelete () {
      if (!await this.$root.$confirm(this.$t('Delete Role'), this.$t('Please Confirm'), { color: 'red' })) {
        return
      }
      await this.role.delete()
      this.goBack()
    }
  }
}
</script>
